export default __webpack_public_path__ + "static/media/1124.ed2bee81.png";